import { Button } from 'RooV1.12';
import React from 'react';
import './index.scss';

const AddCreator: React.FC = () => {
    const handleClick = () => {
        window.open('https://wenjuan.meituan.com/survey/5230070', '_blank');
    };

    return (
        <div className="add-creator">
            <h2 className="add-creator-title">招募创作者</h2>
            <div className="add-creator-content">
                <img
                    src="@/assets/images/creatorRule.png"
                    style={{ width: '1000px', height: '700px' }}
                    alt=""
                />
                <Button onClick={handleClick}>申请成为创作者</Button>
            </div>
        </div>
    );
};

export default AddCreator;
